import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL_HREF, BRAND_NAME } from "@/lib/contact";
import { track } from "@/lib/analytics";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      role="banner"
      className={`fixed top-0 inset-x-0 z-40 transition-all ${
        scrolled ? "glass-header border-b border-border shadow-sm" : "bg-transparent"
      }`}
    >
      <nav
        aria-label="Navigazione principale"
        className="mx-auto max-w-7xl px-4 sm:px-6 h-16 md:h-20 flex items-center justify-between"
      >
        <Link
          to="/"
          className="flex items-center gap-2.5 group"
          data-testid="logo-link"
          aria-label={`${BRAND_NAME} - torna alla home`}
        >
          <img
            src="/logo-mark.png"
            alt=""
            width="44"
            height="44"
            className="h-10 w-10 sm:h-11 sm:w-11 object-contain"
            decoding="async"
          />
          <span
            className={`font-display font-extrabold tracking-tight text-base sm:text-lg leading-none ${
              scrolled ? "text-navy" : "text-white"
            }`}
          >
            {BRAND_NAME}
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href="https://romarottamazioni.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-rottamazione-link"
            aria-label="Vai al sito partner Romarottamazioni.com"
            className={`hidden md:inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold ring-1 transition ${
              scrolled
                ? "text-navy ring-navy/20 hover:bg-navy hover:text-white hover:ring-navy"
                : "text-white ring-white/30 hover:bg-white hover:text-navy hover:ring-white"
            }`}
          >
            Rottamazione
          </a>

          <a
            href={PHONE_TEL_HREF}
            onClick={() => track.phoneCall("header")}
            data-testid="header-call-button"
            aria-label={`Chiama ora ${PHONE_DISPLAY}`}
            className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-3 sm:px-5 py-2.5 text-white font-bold text-sm sm:text-base hover:-translate-y-0.5 hover:brightness-110 transition btn-glow-orange"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            <span className="hidden sm:inline">Chiama Ora</span>
            <span className="font-mono tracking-tight">{PHONE_DISPLAY}</span>
          </a>
        </div>
      </nav>
    </header>
  );
}
